@if (form && fieldName) {
  <div [formGroup]="form">
    <p-select [options]="domainValues"
              [formControlName]="fieldName"
              (onChange)="value = form.controls[fieldName].value; valueChanged($event.value)"
              [placeholder]="placeholder | translate"
              [showClear]="showClear"
              optionLabel="value"
              optionValue="domainValueCd"
              class="grid-comp-full-width" [class.dropdown-xs]="small"
              appendTo="body">
      <ng-template #selectedItem let-option pTemplate="selectedItem">
        <div class="flex align-items-center gap-2">
          @if (option.icon && showIcon) {
            <i [class]="option.icon + ' pl-1'"></i>
          }
          {{option.value | translate}}
        </div>
      </ng-template>
      <ng-template #item let-option pTemplate="item">
        <div class="flex align-items-center gap-2">
          @if (option.icon && showIcon) {
            <i [class]="option.icon"></i>
          }
          {{option.value | translate}}
        </div>
      </ng-template>
    </p-select>
  </div>
} @else {
  <p-select [(ngModel)]="value" [options]="domainValues"
            (onChange)="valueChanged($event.value)"
            [placeholder]="placeholder | translate"
            [showClear]="showClear"
            [disabled]="locked || loading"
            [loading]="loading"
            optionLabel="value"
            optionValue="domainValueCd"
            class="grid-comp-full-width" [class.dropdown-xs]="small"
            appendTo="body">
    <ng-template #selectedItem let-option pTemplate="selectedItem">
      <div class="flex align-items-center gap-2">
        @if (option.icon && showIcon) {
          <i [class]="option.icon + ' pl-1'"></i>
        }
        {{option.value | translate}}
      </div>
    </ng-template>
    <ng-template #item let-option pTemplate="item">
      <div class="flex align-items-center gap-2">
        @if (option.icon && showIcon) {
          <i [class]="option.icon"></i>
        }
        {{option.value | translate}}
      </div>
    </ng-template>
  </p-select>
}
